var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word-limit"},[_vm._v(_vm._s(_vm.inputLength)+"/"+_vm._s(_vm.maxLength))])
}
var staticRenderFns = []

export { render, staticRenderFns }